import React from "react";
import BarcodeReader from "react-barcode-reader";
import {
  Modal,
  Input,
  Form,
  Select,
  Icon,
  DatePicker,
  Tabs,
  Button,
  Tag,
  message,
  Checkbox,
  Radio,
  Spin,
} from "antd";
import moment from "moment";
import "./styles.css";

import {
  FORMAT_NUMBER,
  FORMAT_3DECIMALS,
} from "../../../common/types/regularExpresionType";
import {
  COTIZACION,
  NOTA_VENTA,
  PEDIDO,
} from "../../../common/types/tipoComprobanteType";

import Productos from "./FormModal/Productos";
import Referencias from "./FormModal/Referencias";
import Footer from "./FormModal/Footer";
import auth from "../../../common/utility/auth";
import global from "../../../common/utility/global";
import dialog from "../../../common/utility/dialog";
import MetodoPago from "./FormModal/MetodoPago";

import {
  VENTA_PRECIO_UNITARIO_INCLUYE_IGV,
  IMPUESTO_SELECTIVO_CONSUMO_VENTA,
  PORCENTAJE_PERCEPCION,
  VENTA_DECIMAL,
  SERIE_POR_PRODUCTO
} from "../../../common/types/parametroType";
import { lst_tipo_impuesto } from "../../../common/types/impuestoType";

const InputGroup = Input.Group;
const { Search } = Input;
const { Option } = Select;
const { TabPane } = Tabs;

class FormModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleScan = this.handleScan.bind(this);
  }

  handleScan(data) {
    this.props.onScanerProduct(
      data,
      this.props.form.setFieldsValue,
      this.props.form.getFieldValue
    );
  }
  handleError(err) {
    alert("error");
    console.error(err);
  }

  findDaysAndDates = (property, value) => {
    if (property === "diasVencimiento") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const diasVencimiento = parseInt(value);
      this.props.form.setFieldsValue({
        fechaVencimientoStr: fecha.add("days", diasVencimiento),
      });
    }

    if (property === "fechaVencimientoStr") {
      const fecha = moment(
        this.props.form.getFieldValue("fechaStr"),
        "DD/MM/YYYY"
      );
      const fechaVencimiento = moment(value, "DD/MM/YYYY");
      this.props.form.setFieldsValue({
        diasVencimiento: fechaVencimiento.diff(fecha, "days").toString(),
      });
    }
  };

  handleSearchAutocompleteCliente = async (value) => {
    /*     const result = this.props.formValues.clientes
          .filter((item) => {
            return global
              .formatSearch(`${item.nombre} - ${item.tipoDocumento}`)
              .match(global.formatSearch(value));
          })
          .slice(0, 75); */
    this.props.fetchClientes(value, this.props.form)

  };

  handleChangeAutocompleteCliente = (a, element) => {
    this.props.form.setFieldsValue(
      {
        documentoCliente: element.props.data.numeroDocumento,
      },
      () => {
        this.props.onChange(
          "idCliente",
          element.props.data.idEntidad + "-" + element.props.data.id,
          this.props.form
        );
      }
    );
  };

  handleCompleteDecimals = (property, value) => {
    if (value === "" || isNaN(parseFloat(value).toFixed(3)))
      this.props.form.setFieldsValue({ [property]: "0.000" });
    else
      this.props.form.setFieldsValue({
        [property]: parseFloat(value).toFixed(3),
      });
  };

  handleCalculateDetail = (row, property, value, numberDecimals, index) => {
    var newValue = this.fetchNewValue(value, numberDecimals);
    var params = auth.user().parametros;

    /********* Datos de parametro ******/
    const precioVenta = params.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 5;
    const cantidadVenta = params.filter(m => m.abreviatura === VENTA_DECIMAL)[0].valor === "1" ? 2 : 3;

    var otroImpuesto = this.props.form.getFieldValue("otroImpuesto");
    var porcentajeIGV = lst_tipo_impuesto.find(item => item.id === otroImpuesto?.key)?.value ?? 18;

    var porcentajeISC = parseFloat(
      params.filter(
        (m) => m.abreviatura === IMPUESTO_SELECTIVO_CONSUMO_VENTA
      )[0].valor
    );
    var flagPrecioIncluyeIGV =
      params.filter(
        (m) => m.abreviatura === VENTA_PRECIO_UNITARIO_INCLUYE_IGV
      )[0].valor === "1"
        ? true
        : false;

    /*********** Datos por fila ********/
    var flagAfecto = false;
    var flagExonerado = false;
    var flagGratuito = false;
    var flagISC = false;

    var flagChangeTotal = false;

    var getImpuesto =
      property === "arridImpuesto"
        ? value
        : this.props.form.getFieldValue(`arridImpuesto[${row.identifier}]`).key;


    const selectedImpuesto = this.props.formValues.tipoAfectacion.find(x => x.id === getImpuesto);

    const DEFAULT_CODIGO = '10';
    const codigo = selectedImpuesto?.codigoSunat ?? DEFAULT_CODIGO;

    switch (true) {

      // Gravado
      case ["10", "17"].includes(codigo):
        flagAfecto = true;
        break;

      // Exonerado
      case codigo === "20":
        flagExonerado = true;
        break;

      // Inafecto
      case codigo === "30":
        break;

      // Exportación
      case codigo === "40":
        break;
    }



    var precioUnitario = this.fetchFieldValue(
      row.identifier,
      "arrPrecioUnitario"
    );
    var cantidad = this.fetchFieldValue(row.identifier, "arrCantidad");

    if (property === "arrCantidad") {
      cantidad = parseFloat(value);
    }

    var porcentajeDescuento = this.fetchFieldValue(
      row.identifier,
      "arrPorcentajeDescuento"
    );
    var importeDescuento = this.fetchFieldValue(
      row.identifier,
      "arrImporteDescuento"
    );
    var total = this.fetchFieldValue(row.identifier, "arrTotal");
    var UnidadMedida = this.props.form.getFieldValue(`arridUnidadMedida[${row.identifier}]`).key;
    var LstUnidadMedida = this.props.formValues.unidadesMedida.filter((m) => m.nombre == UnidadMedida);
    var idUnidadMedida = LstUnidadMedida.length == 0 ? UnidadMedida : LstUnidadMedida[0].id;


    if (porcentajeDescuento > 100) {
      message.warning("El porcentaje de descuento no puedo ser mayor a 100%");
      return;
    }

    /*********** VALIDACION CASOS EXONERADOS INAFECTOS ********/

    if (!flagAfecto) {
      flagPrecioIncluyeIGV = 0;
    }
    if (property == "arridUnidadMedida") {
      idUnidadMedida = value;
    }

    /*********** Datos por fila (bloquear checks) ********/
    if (flagGratuito) {
      flagAfecto = false;
      flagISC = false;
    }
    if (value == false && property === "arrFlagGratuito") {
      flagAfecto = row.flagAfecto;
      flagISC = row.flagISC;
    }
    /*********** Calculo precios unitarios ********/
    var divisorCalculoSubTotal = 1 + porcentajeIGV / 100;
    var precioUnitarioSinIGV = flagPrecioIncluyeIGV
      ? precioUnitario / divisorCalculoSubTotal
      : precioUnitario;

    /*********** Calculo por ISC ********/
    var importeISC = flagISC ? precioUnitarioSinIGV * (porcentajeISC / 100) : 0;
    var precioUnitarioISC = flagISC ? precioUnitarioSinIGV + importeISC : 0;
    var totalDetalle = flagISC
      ? cantidad * precioUnitarioISC
      : cantidad * precioUnitarioSinIGV;

    /*********** Calculo totales ********/
    var subTotal = totalDetalle;
    var igv = parseFloat(
      (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
    );
    total = parseFloat((subTotal + igv).toFixed(2));

    if (property === "arrTotal" && parseFloat(newValue) !== total) {
      flagISC = false;
      importeISC = 0;
      precioUnitarioISC = 0;
      flagChangeTotal = true;

      /*********** Calculo totales ********/
      total = parseFloat(value);
      porcentajeDescuento = 0;
      importeDescuento = 0;
      subTotal = parseFloat(
        (flagAfecto ? total / (1 + porcentajeIGV / 100) : total).toFixed(2)
      );

      /*********** Calculo por ISC ********/
      totalDetalle = flagISC ? cantidad * precioUnitarioISC : subTotal;

      /*********** Calculo Cantidad ********/
      cantidad = parseFloat((subTotal / precioUnitarioSinIGV).toFixed(2));
      if (cantidad === 0) cantidad = 1;

      /*********** Calculo IGV ********/
      igv = flagAfecto ? subTotal * (porcentajeIGV / 100) : 0;
    }

    /*********** Calculo descuentos ********/
    if (importeDescuento > 0 || porcentajeDescuento > 0) {
      var calculoimporteDescuento = 0;
      if (flagPrecioIncluyeIGV) {
        calculoimporteDescuento = parseFloat(
          (total * (porcentajeDescuento / 100)).toFixed(2)
        );
      } else {
        calculoimporteDescuento = parseFloat(
          (totalDetalle * (porcentajeDescuento / 100)).toFixed(2)
        );
      }

      if (
        importeDescuento !== calculoimporteDescuento &&
        property === "arrImporteDescuento"
      )
        porcentajeDescuento = 0;
      else importeDescuento = calculoimporteDescuento;

      if (flagPrecioIncluyeIGV) {
        total = total - importeDescuento;

        if (flagAfecto) {
          subTotal = parseFloat((total / divisorCalculoSubTotal).toFixed(2));
          igv = total - subTotal;
          totalDetalle = subTotal;
        } else {
          subTotal = total;
          igv = 0;
          totalDetalle = subTotal;
        }
      } else {
        subTotal = subTotal - importeDescuento;

        if (flagAfecto) {
          var igv = parseFloat(
            (flagAfecto ? subTotal * (porcentajeIGV / 100) : 0).toFixed(2)
          );
          total = parseFloat((subTotal + igv).toFixed(2));
        } else {
          total = subTotal;
          subTotal = subTotal;
          igv = 0;
          totalDetalle = subTotal;
        }
      }
    }

    /*********** Calculo gratuito ********/
    if (flagGratuito) {
      porcentajeDescuento = 0;
      importeDescuento = 0;
      igv = 0;
      subTotal = 0;
      total = 0;
    }

    /*********** Actualizar Detalle de Productos ********/
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    var dataNueva = {
      identifier: row.identifier,
      numeroLote: this.props.form.getFieldValue(`arrNumeroLote[${row.identifier}]`),
      nombre: this.props.form.getFieldValue(`arrNombre[${row.identifier}]`),
      codigo: this.props.form.getFieldValue(`arrcodigo[${row.identifier}]`),
      idProducto: row.idProducto,
      idTipoProducto: row.idTipoProducto,
      precioPromedio: row.precioPromedio,
      porcentajeMargenComercial: row.porcentajeMargenComercial,
      flagAplicarSerie: row.flagAplicarSerie,
      listaDetalleSerie: row.listaDetalleSerie,
      detalleSeries: row.detalleSeries,
      cantidad,
      precioUnitarioSinIGV,
      precioUnitario,
      porcentajeDescuento,
      importeDescuento,
      total,
      flagAfecto,
      flagISC,
      flagOtrosImpuesto: false, // OMITIDO POR EL MOMENTO
      flagGratuito,
      flagChangeTotal,
      subTotal,
      isItemLibre: row.isItemLibre == undefined ? false : row.isItemLibre,
      idUnidadMedida: idUnidadMedida,
      idImpuesto: selectedImpuesto?.id ?? 1,
      flagConversion: row.flagConversion
    };
    detalleProductosFilter.splice(index, 0, dataNueva);

    /*********** Re-Calcular Suma SubTotal ********/

    var sumaTotalAfecto = this.fetchSumaTotalAfecto(
      row.identifier,
      codigo,
      total
    );
    var sumaTotalInafecto = this.fetchSumaTotalInafecto(
      row.identifier,
      codigo,
      total
    );

    var fetchSumaTotalExonerado = this.fetchSumaTotalExonerado(
      row.identifier,
      codigo,
      total
    );

    var fetchSumaTotalGratuito = this.fetchSumaTotalGratuito(
      row.identifier,
      codigo,
      total
    );

    /*********** Calculo suma detalle ********/
    var sumaImporteDescuento = this.fetchFieldValueSum(
      row.identifier,
      "arrImporteDescuento",
      importeDescuento
    );
    var sumaIsc = this.fetchFieldValueSum(
      row.identifier,
      "arrIsc",
      cantidad === 0 ? 0 : importeISC
    );
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", total);
    var sumaSubTotal = parseFloat(
      (
        sumaTotalAfecto / divisorCalculoSubTotal +
        (sumaTotalInafecto + fetchSumaTotalExonerado + fetchSumaTotalGratuito)
      ).toFixed(2)
    );
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;

    this.props.form.setFieldsValue({
      sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      [`arrFlagAfecto[${row.identifier}]`]: flagAfecto,
      [`arrFlagGratuito[${row.identifier}]`]: flagGratuito,
      [`arrFlagISC[${row.identifier}]`]: flagISC,
      [`arrIsc[${row.identifier}]`]: cantidad === 0 ? 0 : importeISC,
      [`arrPrecioUnitario[${row.identifier}]`]: precioUnitario.toFixed(precioVenta),
      [`arrCantidad[${row.identifier}]`]: cantidad.toFixed(cantidadVenta),
      [`arrTotalDetalle[${row.identifier}]`]: totalDetalle.toFixed(2),
      [`arrPorcentajeDescuento[${row.identifier}]`]:
        porcentajeDescuento.toFixed(2),
      [`arrImporteDescuento[${row.identifier}]`]: importeDescuento.toFixed(2),
      [`arrSubTotal[${row.identifier}]`]: subTotal.toFixed(2),
      [`arrIgv[${row.identifier}]`]: igv.toFixed(2),
      [`arrTotal[${row.identifier}]`]: total.toFixed(2),
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    setTimeout(() => { this.handleCalculateMetodoPago(sumaTotal) }, 500)
  };

  handleRemoverProducto = (row) => {
    var detalleProductos = this.props.form.getFieldValue("detalleProductos");
    var detalleProductosFilter = detalleProductos.filter((m) => {
      return m.identifier !== row.identifier;
    });

    var sumaImporteDescuento = this.fetchFieldValueSum(
      row.identifier,
      "arrImporteDescuento",
      0
    );
    var sumaIsc = this.fetchFieldValueSum(row.identifier, "arrIsc", 0);
    var sumaTotal = this.fetchFieldValueSum(row.identifier, "arrTotal", 0);
    var sumaSubTotal = this.fetchFieldValueSum(
      row.identifier,
      "arrSubTotal",
      0
    );
    var sumaIgv = sumaTotal - sumaSubTotal;
    var sumaTotalDetalle = sumaSubTotal;

    /*********** Calculo de Totales 2 ********/
    var flagPercepcion = this.props.form.getFieldValue("flagPercepcion");
    var flagDetraccion = this.props.form.getFieldValue("flagDetraccion");

    var porcentajePercepcion = parseFloat(
      auth
        .user()
        .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
        .valor
    );
    var importePercepcion = sumaTotal * (porcentajePercepcion / 100);
    var totalPercepcion = sumaTotal + importePercepcion;

    var porcentajeDetraccion = this.props.form.getFieldValue(
      "porcentajeDetraccion"
    );
    var importeDetraccion = sumaTotal * (porcentajeDetraccion / 100);
    var totalDetraccion = sumaTotal - importeDetraccion;

    this.props.form.setFieldsValue({
      sumaImporteDescuento: sumaImporteDescuento,
      sumaIsc: sumaIsc,
      sumaTotal: sumaTotal,
      sumaSubTotal: sumaSubTotal,
      sumaIgv: sumaIgv,
      sumaTotalDetalle: sumaTotalDetalle,
      detalleProductos: detalleProductosFilter,
      porcentajePercepcion: flagPercepcion ? porcentajePercepcion : 0,
      importePercepcion: flagPercepcion ? importePercepcion : 0,
      totalPercepcion: flagPercepcion ? totalPercepcion : 0,
      porcentajeDetraccion: flagDetraccion ? porcentajeDetraccion : 0,
      importeDetraccion: flagDetraccion ? importeDetraccion : 0,
      totalDetraccion: flagDetraccion ? totalDetraccion : 0,
    });

    this.props.onRemoverProducto(row, this.props.form);
    setTimeout(() => { this.handleCalculateMetodoPago(sumaTotal) }, 500)


  };

  fetchNewValue = (value, numberDecimals) => {
    if (numberDecimals === 2)
      return value === "" || isNaN(parseFloat(value).toFixed(2))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 3)
      return value === "" || isNaN(parseFloat(value).toFixed(3))
        ? 0
        : parseFloat(value);
    if (numberDecimals === 5)
      return value === "" || isNaN(parseFloat(value).toFixed(5))
        ? 0
        : parseFloat(value);

    return 0;
  };

  fetchFieldValue = (identifier, property) => {
    var result = parseFloat(
      this.props.form.getFieldValue(`${property}[${identifier}]`)
    );
    return result;
  };

  fetchFieldValueSum = (identifier, property, paramValue) => {
    var suma = 0;
    var obj = Object.assign({}, this.props.form.getFieldValue(property));

    for (var [key, value] of Object.entries(obj)) {
      suma = suma + (key === identifier ? paramValue : parseFloat(value));
    }

    return suma;
  };

  fetchSumaTotalAfecto = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 10 o 17
      var esGravado = ["10", "17"].includes(codigo);

      if (esGravado) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };

  fetchSumaTotalInafecto = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 30
      const esInafecto = ["30"].includes(codigo);


      if (esInafecto) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchSumaTotalExonerado = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 20
      const esExonerado = ["20"].includes(codigo);

      if (esExonerado) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  fetchSumaTotalGratuito = (
    identifier,
    codex,
    total
  ) => {
    let suma = 0;

    const arrTotal = this.props.form.getFieldValue("arrTotal");
    const arrImpuesto = this.props.form.getFieldValue("arridImpuesto");

    for (const [key, value] of Object.entries(arrTotal)) {

      // 👉 obtenemos el id del impuesto
      const impuestoKey = arrImpuesto?.[key]?.key;

      const selectedImpuesto = this.props.formValues.tipoAfectacion.find(
        x => x.id === impuestoKey
      );

      const codigo = identifier === key ? codex : selectedImpuesto?.codigoSunat;

      // ✅ solo sumar si es 20
      const esGratuito = !["10", "20", "30", "40", "17"].includes(codigo);

      if (esGratuito) {
        suma +=
          identifier === key
            ? Number(total.toFixed(2))
            : parseFloat(value);
      }
    }

    return suma;
  };


  handleChangeTotals = (property, value) => {
    if (property === "flagPercepcion" && value) {
      var porcentajePercepcion = parseFloat(
        auth
          .user()
          .parametros.filter((m) => m.abreviatura === PORCENTAJE_PERCEPCION)[0]
          .valor
      );
      var importePercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) *
        (porcentajePercepcion / 100);
      var totalPercepcion =
        this.fetchFieldValueSum("", "arrTotal", 0) + importePercepcion;

      this.props.form.setFieldsValue({
        porcentajePercepcion,
        importePercepcion,
        totalPercepcion,
        flagDetraccion: false,
        porcentajeDetraccion: 0,
        importeDetraccion: 0,
        totalDetraccion: 0,
        idDetraccion: undefined,
      });
    }

    if (property === "flagDetraccion" && value) {
      this.props.form.setFieldsValue(
        {
          flagPercepcion: false,
        },
        () => {
          this.props.form.validateFields(["idDetraccion"], { force: true });
        }
      );
    }

    if (property === "idDetraccion") {
      var importeDetraccion =
        this.fetchFieldValueSum("", "arrTotal", 0) * (value / 100);
      var totalDetraccion =
        this.fetchFieldValueSum("", "arrTotal", 0) - importeDetraccion;

      this.props.form.setFieldsValue({
        flagPercepcion: false,
        porcentajePercepcion: 0,
        importePercepcion: 0,
        totalPercepcion: 0,
        porcentajeDetraccion: value,
        importeDetraccion,
        totalDetraccion,
      });
    }
  };

  fetchReferencias = (values) => {

    var result = [];

    var flagReferencia = this.props.form.getFieldValue("flagReferencia");
    if (!flagReferencia) {
      this.props.formValues.listaComprobanteReferencia.forEach((item) => {
        result.push({
          idTipoComprobante: item.idTipoComprobante,
          flagInterno: item.flagInterno,
          idReferenciaOrigen: item.idReferenciaOrigen,
          idReferencia: item.idReferencia,
          serie: item.serie,
          documento: item.documento,
        });
      });
      return result;
    }

    if (
      values.arrTipoComprobante === undefined ||
      values.arrSerie === undefined ||
      values.arrDocumento === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrTipoComprobante);

    for (var [key, value] of Object.entries(obj)) {
      keys.push(key);
    }

    keys.forEach((key) => {
      result.push({
        idTipoComprobante: values.arrTipoComprobante[key].key,
        serie: values.arrSerie[key],
        documento: values.arrDocumento[key],
        idReferencia: values.arrIdReferencia[key],
        idReferenciaOrigen: values.arrIdReferenciaOrigen[key],
        flagInterno: values.arrFlagInterno[key],
      });
    });

    return result;
  };

  handleCancel = () => {
    this.props.onClose();
    this.props.form.resetFields();
  };

  handleValidateStock = (products, stockProducts) => {

    var elements = [];
    const productGroup = global.groupBy(products, (item) => [
      item.idProducto,
      item.numeroLote,
    ]);

    productGroup.forEach((item) => {
      /**** BUSCAR STOCK POR PRODUCTO Y LOTE ***/
      var stock = stockProducts.filter(
        (m) =>
          m.idProducto === item[0].idProducto &&
          m.numeroLote === item[0].numeroLote
      )[0].stock;

      /**** FILTRAR PRODUCTOS POR ID Y LOTE ***/
      var filteredProducts = products.filter(
        (m) =>
          m.idProducto === item[0].idProducto &&
          m.numeroLote === item[0].numeroLote
      );

      /**** SUMAR CANTIDAD DE PRODUCTOS POR ID Y LOTE ***/
      var total = filteredProducts.reduce(
        (a, b) => a + (b["cantidad"] || 0),
        0
      );

      /**** OBTENER NOMBRE DE PRODUCTOS AFECTADOS POR STOCK ***/
      var productNames = Array.from(
        new Set(filteredProducts.map((m) => m.nombre))
      );

      if (total > stock) {
        elements.push(
          <li>
            Stock no disponible para los productos:{" "}
            <b>{productNames.join(", ")}</b>
          </li>
        );
      }
    });

    return elements;
  };

  handleValidatDetalleAfecto = (products) => {
    var elements1 = [];
    var elements2 = [];
    products.forEach((item) => {
      if (item.flagAfecto) {
        elements1.push(item);
      } else {
        if (item.flagGratuito || item.flagISC) {
          elements1.push(item);
        } else {
          elements2.push(item);
        }
      }
    });

    if (
      elements1.length === products.length ||
      elements2.length === products.length
    )
      return true;
    else return false;
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {

      if (values.detalleProductos.filter(m => { return m.flagAplicarSerie === true; }).length > 0) {
        values.detalleProductos.forEach(row => {
          if (row.listaDetalleSerie.length === 0 && row.flagAplicarSerie) {
            message.warning("Por favor agregue las series para el producto " + row.nombre);
            return false;
          }
        });
      }

      if (!err) {
        var flagPago = values.flagPago == undefined ? false : values.flagPago;
        const porcentajeIGV = lst_tipo_impuesto.find(item => item.id === values.otroImpuesto?.key)?.value ?? 18;

        const data = {
          id: values.id,
          idTipoComprobante: values.idTipoComprobante,
          idCliente: values.idCliente === undefined ? 0 : values.idCliente.key,
          idEstablecimientoCliente:
            values.idEstablecimientoCliente === undefined
              ? 0
              : values.idEstablecimientoCliente.key,
          idVendedor:
            values.idVendedor === undefined ? 0 : values.idVendedor.key,
          idAlmacen: values.idAlmacen.key,
          idMoneda: values.idMoneda.key,
          idCaja: 0,
          idListaPrecio: values.idListaPrecio.key,
          idEstablecimiento: values.idEstablecimiento.key,
          idCotizacionEstado: 1,
          idPedidoEstado: 1,
          idNotaVentaEstado: 1,
          idProyecto: values.idProyecto.key == null ? 0 : values.idProyecto.key,

          idFenologica: values.idFenologica === undefined ? 0 : values.idFenologica.key,
          idCultivo: values.idCultivo === undefined ? 0 : values.idCultivo.key,

          idUsuarioRegistro: values.idUsuarioRegistro,
          serie: values.serie.toUpperCase(),
          documento: "", //values.documento,
          fechaStr: values.fechaStr.format("DD/MM/YYYY"),
          fechaVencimientoStr: values.fechaVencimientoStr.format("DD/MM/YYYY"),
          diasVencimiento: parseInt(values.diasVencimiento),
          tipoCambio: parseFloat(values.tipoCambio),
          observacion: values.observacion,
          porcentajeIGV: porcentajeIGV,
          porcentajeDescuento: 0,
          totalDetalleAfecto: 0,
          totalDetalleInafecto: 0,
          totalDetalleGratuito: 0,
          totalDetalle: 0,
          flagPago: flagPago,
          importeDescuento: values.sumaImporteDescuento,
          subTotal: values.sumaSubTotal,
          iGV: values.sumaIgv,
          total: values.sumaTotal,
          isc: values.sumaIsc,
          IdPendientePago: values.idPendiente.key, // 
          numeroPlaca: values.numeroPlaca,
          Flag: true,
          encargado: values.encargado === undefined ? "" : values.encargado,
          idVehiculo: values.idVehiculo === undefined ? 0 : values.idVehiculo.key,
          listaComprobanteDetalle: values.detalleProductos,
          listaComprobanteReferencia: this.fetchReferencias(values),
          listaComprobanteMetodoPago: flagPago ? this.fetchMetodoPago(values) : [],

        };

        if (!this.handleValidatDetalleAfecto(values.detalleProductos)) {
          dialog.warning("El detalle de productos no puedo contener afectos e inafectos.");
          return;
        }
        var montoPago = data.listaComprobanteMetodoPago.reduce((a, b) => a + (b["montoPago"] || 0), 0);

        if (data.flagPago) {
          if (data.listaComprobanteMetodoPago.length === 0) {
            dialog.warning("Por favor agregue metodo de pago.");
            return;
          }

          if (data.total != parseFloat(montoPago)) {
            dialog.warning("el monto de pago debe ser igual al monto total del documento");
            return;
          }

        }

        if (values.idCliente === 0 || values.idCliente === undefined) {
          dialog.warning('Seleccione un cliente.');
          return;
        }
        
        if (data.listaComprobanteDetalle.length === 0) {
          dialog.warning("Por favor agregue por lo menos 1 producto.");
          return;
        }

        this.props.onSave(data, this.props.form);
      }
    });
  };

  //#region  [MEDIO DE PAGO]

  fetchMetodoPago = (values) => {
    var result = [];
    var flagPago = this.props.form.getFieldValue("flagPago");
    var flagMetodoPago = this.props.form.getFieldValue("flagMetodoPago");

    if (!flagMetodoPago) {
      this.props.formValues.listaComprobanteMetodoPago.forEach((item) => {
        result.push({
          fechaPagoStr: item.fechaPago,
          idMetodoPago: item.idMetodoPago,
          idCuenta: item.idCuenta,
          referencia: item.referencia,
          montoPago: item.montoPago,
          idCajaApertura: flagPago ? values.idCaja.key : 0,
          idMoneda: values.idMoneda.key

        });
      });
      return result;
    }

    if (
      values.arrFechaPago === undefined ||
      values.arrMontoPago === undefined
    )
      return result;

    var keys = [];
    var obj = Object.assign({}, values.arrFechaPago);

    for (var [key] of Object.entries(obj)) {
      keys.push(key);
    }
    keys.forEach((key) => {

      var cuenta = values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key;
      var banco = cuenta == 0 ? 0 : this.props.formValues.cuentas.filter(e => e.id = cuenta);

      result.push({
        fechaPagoStr: values.arrFechaPago[key].format("DD/MM/YYYY"),
        idMetodoPago: values.arrIdTipoMetodoPago[key].key,
        idCuenta: values.arrIdCuenta[key] === undefined ? 0 : values.arrIdCuenta[key].key,
        referencia: values.arrReferenciaPago[key],
        montoPago: parseFloat(values.arrMontoPago[key]),
        idCajaApertura: flagPago ? values.idCaja.key : 0,
        idMoneda: values.idMoneda.key,
        idBanco: banco == 0 ? 0 : banco[0].idBanco

      });
    });


    return result;
  };

  //#endregion  [END MEDIO DE PAGO]


  fetchParameters = () => {
    var parameters = {};
    this.props.formValue.parameters.forEach((item) => {
      parameters[item.key] = item.value;
    });
    return parameters;
  };

  handleCalculateMetodoPago = (sumaTotal) => {

    this.props.onCalculateMetodoPago(sumaTotal, this.props.form);
  }


  render() {
    const { getFieldDecorator, setFieldsValue, getFieldValue } = this.props.form;
    const seriePorProducto = auth.user().parametros.filter(m => m.abreviatura === SERIE_POR_PRODUCTO)[0].valor === "1" ? true : false;

    getFieldDecorator("id", { initialValue: this.props.formValues.id });
    getFieldDecorator("clientes", {
      initialValue: this.props.formValues.clientes.filter((m) => {
        return m.id === this.props.formValues.idCliente;
      }),
    });
    getFieldDecorator("idTipoComprobante", {
      initialValue: this.props.formValues.idTipoComprobante,
    });
    getFieldDecorator("flagGrifo", {
      initialValue: this.props.formValues.flagGrifo,
    });
    getFieldDecorator("idUsuarioRegistro", {
      initialValue: this.props.formValues.idUsuarioRegistro,
    });
    getFieldDecorator("sumaTotalDetalle", {
      initialValue: this.props.formValues.sumaTotalDetalle,
    });
    getFieldDecorator("sumaImporteDescuento", {
      initialValue: this.props.formValues.sumaImporteDescuento,
    });
    getFieldDecorator("sumaSubTotal", {
      initialValue: this.props.formValues.sumaSubTotal,
    });
    getFieldDecorator("sumaIgv", {
      initialValue: this.props.formValues.sumaIgv,
    });
    getFieldDecorator("sumaIsc", {
      initialValue: this.props.formValues.sumaIsc,
    });
    getFieldDecorator("sumaTotal", {
      initialValue: this.props.formValues.sumaTotal,
    });
    getFieldDecorator("detalleProductos", {
      initialValue: this.props.formValues.detalleProductos,
    });

    getFieldDecorator("porcentajeDetraccion", {
      initialValue: this.props.formValues.porcentajeDetraccion,
    });
    getFieldDecorator("importeDetraccion", {
      initialValue: this.props.formValues.importeDetraccion,
    });
    getFieldDecorator("totalDetraccion", {
      initialValue: this.props.formValues.totalDetraccion,
    });
    getFieldDecorator("porcentajePercepcion", {
      initialValue: this.props.formValues.porcentajePercepcion,
    });
    getFieldDecorator("importePercepcion", {
      initialValue: this.props.formValues.importePercepcion,
    });
    getFieldDecorator("totalPercepcion", {
      initialValue: this.props.formValues.totalPercepcion,
    });
    getFieldDecorator("idTipoComprobanteImportado", {
      initialValue: this.props.formValues.idTipoComprobanteImportado,
    });
    getFieldDecorator("flagReferencia", {
      initialValue: false,
    });

    getFieldDecorator("flagMetodoPago", {
      initialValue: false,
    });

    getFieldDecorator("idTipoPrecio", {
      initialValue: this.props.formValues.idTipoPrecio,
    });

    getFieldDecorator("flagPago", {
      initialValue: false,
    });

    var title = "";

    if (this.props.formValues.idTipoComprobante === COTIZACION.ID)
      title = "Cotización";
    if (this.props.formValues.idTipoComprobante === PEDIDO.ID)
      title = "Nota de Pedido";
    if (this.props.formValues.idTipoComprobante === NOTA_VENTA.ID)
      title = "Nota de Venta";

    return (
      <Modal
        title={
          this.props.formValues.id === 0
            ? `Registrar ${title}`
            : `Modificar ${title}`
        }
        visible={this.props.visible}
        cancelText={"Cancelar"}
        okText={"Guardar"}
        onCancel={(properties) => {
          if (
            !properties.target.className.toString().match("ant-modal-wrap") ||
            properties.type === "keydown"
          )
            this.handleCancel();
        }}
        onOk={this.handleOk}
        style={{ top: 30 }}
        width="1100px"
      >
        <BarcodeReader onError={this.handleError} onScan={this.handleScan} />

        <Form>
          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Fecha / Tipo de Cambio">
                <InputGroup compact>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaStr", {
                      initialValue: moment(
                        this.props.formValues.fechaStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        className="first-input"
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        onChange={(moment, value) =>
                          this.props.onChange(
                            "fechaStr",
                            value,
                            this.props.form
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("tipoCambio", {
                      initialValue: parseFloat(
                        this.props.formValues.tipoCambio
                      ).toFixed(3),
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_3DECIMALS),
                          message: "Formato decimal incorrecto (0.000)",
                        },
                      ],
                    })(
                      <Input
                        className="text-right second-input"
                        placeholder="Ingresar Tipo de Cambio"
                        autoComplete="off"
                        onBlur={(e) =>
                          this.handleCompleteDecimals(
                            "tipoCambio",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Serie / Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "40%" }}>
                    {getFieldDecorator("serie", {
                      initialValue: this.props.formValues.serie,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Input
                        placeholder="Serie"
                        autoComplete="off"
                        className="first-input"
                        style={{ textTransform: "uppercase" }}
                        disabled
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "60%" }}>
                    {getFieldDecorator("documento", {
                      initialValue: this.props.formValues.documento,
                    })(
                      <Input
                        placeholder="Documento"
                        autoComplete="off"
                        className="second-input"
                        maxLength={8}
                        disabled
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Días / Fecha de Vencimiento">
                <InputGroup compact>
                  <Form.Item style={{ width: "35%" }}>
                    {getFieldDecorator("diasVencimiento", {
                      initialValue: this.props.formValues.diasVencimiento,
                      rules: [
                        {
                          required: true,
                          pattern: new RegExp(FORMAT_NUMBER),
                          message: "Formato incorrecto",
                        },
                      ],
                    })(
                      <Input
                        style={{ textAlign: "right" }}
                        placeholder="Ingresar días de vencimiento"
                        autoComplete="off"
                        className="first-input"
                        onBlur={(e) =>
                          this.findDaysAndDates(
                            "diasVencimiento",
                            e.target.value
                          )
                        }
                      />
                    )}
                  </Form.Item>
                  <Form.Item style={{ width: "65%" }}>
                    {getFieldDecorator("fechaVencimientoStr", {
                      initialValue: moment(
                        this.props.formValues.fechaVencimientoStr,
                        "DD/MM/YYYY"
                      ),
                      rules: [
                        {
                          type: "object",
                          required: true,
                          message: "Requerido",
                        },
                      ],
                    })(
                      <DatePicker
                        placeholder="Seleccione fecha"
                        prefix={
                          <Icon
                            type="filter"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        format="DD/MM/YYYY"
                        className="second-input"
                        onChange={(moment, value) =>
                          this.findDaysAndDates("fechaVencimientoStr", value)
                        }
                      />
                    )}
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Moneda">
                {getFieldDecorator("idMoneda", {
                  initialValue: this.props.formValues.idMoneda
                    ? { key: this.props.formValues.idMoneda }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Moneda"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      this.props.form.setFieldsValue(
                        {
                          idListaPrecio: undefined,
                        },
                        () => {
                          this.props.onChange("idMoneda", option.key);
                        }
                      );
                    }}
                  >
                    {this.props.formValues.monedas.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Establecimiento">
                {getFieldDecorator("idEstablecimiento", {
                  initialValue: this.props.formValues.idEstablecimiento
                    ? { key: this.props.formValues.idEstablecimiento }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Establecimiento"}
                    optionFilterProp="children"
                    onChange={(option) => {
                      /*               this.props.form.setFieldsValue({
                                      idAlmacen: undefined,
                                      idListaPrecio: undefined,
                                    }); */
                      this.props.onChange(
                        "idEstablecimiento",
                        option.key,
                        this.props.form
                      );
                    }}
                  >
                    {this.props.formValues.establecimientos.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Almacén">
                {getFieldDecorator("idAlmacen", {
                  initialValue: this.props.formValues.idAlmacen
                    ? { key: this.props.formValues.idAlmacen }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Almacén"}
                    optionFilterProp="children"
                    loading={this.props.formValues.almacenLoading}
                    onChange={(option) =>
                      this.props.onChange(
                        "idAlmacen",
                        option.key,
                        this.props.form
                      )
                    }
                  >
                    {this.props.formValues.almacenes.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Lista de Precio">
                {getFieldDecorator("idListaPrecio", {
                  initialValue: this.props.formValues.idListaPrecio
                    ? { key: this.props.formValues.idListaPrecio }
                    : undefined,
                  rules: [
                    {
                      required: true,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Lista de Precio"}
                    optionFilterProp="children"
                    onChange={(option) =>
                      this.props.onChange(
                        "idListaPrecio",
                        option.key,
                        this.props.form
                      )
                    }
                  >
                    {this.props.formValues.listasPrecio.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Vendedor">
                {getFieldDecorator("idVendedor", {
                  initialValue: this.props.formValues.idVendedor
                    ? { key: this.props.formValues.idVendedor }
                    : undefined,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Vendedor"}
                    optionFilterProp="children"
                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.vendedores.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.razonSocialEntidad}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className="col-md-3 form-group">
              <Form.Item label="Nro Documento">
                <InputGroup compact>
                  <Form.Item style={{ width: "100%" }}>
                    {getFieldDecorator("documentoCliente", {
                      initialValue: this.props.formValues.documentoCliente,
                    })(
                      <Search
                        placeholder="Documento"
                        className="first-input"
                        autoComplete="off"
                        loading={this.props.formValues.clienteLoading}
                        onSearch={(value) =>
                          this.props.onBuscarCliente(value, this.props.form)
                        }
                        maxLength={20}
                      />
                    )}
                  </Form.Item>

                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-6 form-group">
              <Form.Item label="Cliente">
                <InputGroup compact>

                  <Form.Item style={{ width: "100%" }}>
                    <InputGroup compact style={{ marginBottom: "1px" }}>
                      {getFieldDecorator("idCliente", {
                        initialValue: this.props.formValues.idCliente
                          ? { key: this.props.formValues.idCliente }
                          : undefined,
                      })(
                        <Select
                          showSearch
                          labelInValue
                          style={{
                            width: `calc(100% - 80px)`,
                            borderTopLeftRadius: "0px",
                          }}
                          placeholder={"Búsqueda de Cliente"}
                          optionFilterProp="children"
                          showArrow={false}
                          notFoundContent={this.props.fetching ? <Spin size="small" /> : null}
                          filterOption={false}
                          onSearch={this.handleSearchAutocompleteCliente}
                          onChange={this.handleChangeAutocompleteCliente}
                        >
                          {getFieldValue("clientes").map((item) => (
                            <Option key={item.id} value={item.id} data={item}>
                              <Tag>{item.tipoDocumentoNombre}</Tag>
                              {`${item.nombre}`}
                            </Option>
                          ))}
                        </Select>
                      )}
                      <Button
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={
                          this.props.form.getFieldValue("idCliente")
                            ? "close"
                            : "search"
                        }
                        onClick={() => {
                          this.props.form.setFieldsValue(
                            {
                              idCliente: undefined,
                              documentoCliente: "",
                              idEstablecimientoCliente: undefined,
                            },
                            () => {
                              this.props.onChange("direcciones-clear");
                            }
                          );
                        }}
                      />

                      <Button
                        className="btn-autocomplete"
                        style={{ width: "40px", fontSize: "14px" }}
                        icon={"plus"}
                        onClick={() => {
                          this.props.onNewCliente(
                            this.props.form.setFieldsValue,
                            this.props.form.getFieldValue
                          );
                        }}
                      />
                    </InputGroup>
                  </Form.Item>
                </InputGroup>
              </Form.Item>
            </div>

            <div className="col-md-3 form-group"  >
              <Form.Item label="IGV">
                {getFieldDecorator("otroImpuesto", {
                  initialValue: this.props.formValues.otroImpuesto
                    ? { key: this.props.formValues.otroImpuesto }
                    : undefined,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"IGV"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("otroImpuesto", option.key, this.props.form)}
                  >
                    {this.props.formValues.Tipoimpuesto.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>



            <div className="col-md-9 form-group">
              <Form.Item label="Dirección">
                {getFieldDecorator("idEstablecimientoCliente", {
                  initialValue: this.props.formValues.idEstablecimientoCliente
                    ? { key: this.props.formValues.idEstablecimientoCliente }
                    : undefined,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Direccion"}
                    optionFilterProp="children"
                  >
                    {this.props.formValues.direcciones.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre + " - " + item.direccion}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group">
              <Form.Item label="Proyecto">
                {getFieldDecorator("idProyecto", {
                  initialValue: this.props.formValues.idProyecto
                    ? { key: this.props.formValues.idProyecto }
                    : 0,
                })(
                  <Select
                    showSearch
                    labelInValue
                    placeholder={"Seleccione Proyecto"}
                    optionFilterProp="children"
                    disabled={this.props.formValues.isReadOnly}
                  >
                    <Option key={0} value={0}>
                      <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                    </Option>
                    {this.props.formValues.proyectos.map(item => (
                      item.estado ?
                        <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        : null
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
            <div className="col-md-3 form-group" hidden={true} >
              <Form.Item label="Estado de Pago">
                {getFieldDecorator("idPendiente", {
                  initialValue: this.props.formValues.idPendiente
                    ? { key: this.props.formValues.idPendiente }
                    : undefined,
                  rules: [
                    {
                      required: false,
                      message: "Campo obligatorio.",
                    },
                  ],
                })(
                  <Select
                    showSearch
                    disabled={true}
                    labelInValue
                    placeholder={"Pendiente de Pago"}
                    optionFilterProp="children"
                    onChange={(option) => this.props.onChange("idPendiente", option.key, this.props.form)}
                  >
                    {this.props.formValues.pendientePago.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.nombre}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </div>
          </div>
          <div className="row">
            <div className={this.props.formValues.flagEmpresaGrifo ? "col-md-9 form-group" : "col-md-12 form-group"} >
              <Form.Item label="Observación">
                {getFieldDecorator("observacion", {
                  initialValue: this.props.formValues.observacion,
                })(
                  <Input
                    placeholder="Ingresar Observación"
                    autoComplete="off"
                  />
                )}
              </Form.Item>
            </div>

            {this.props.formValues.flagEmpresaGrifo ? (
              <div className="col-md-3 form-group">
                <Form.Item label="N° Placa">
                  {getFieldDecorator("numeroPlaca", {
                    initialValue: this.props.formValues.numeroPlaca,
                  })(
                    <Input placeholder="Ingresar N° Placa" autoComplete="off" />
                  )}
                </Form.Item>
              </div>
            ) : null}


            {auth.user().parametros.filter((m) => m.abreviatura == "PAGRO")[0].valor == "1" ? (

              <>
                <div className="col-md-3 form-group">
                  <Form.Item label="Cultivo">
                    {getFieldDecorator('idCultivo', {
                      initialValue: this.props.formValues.idCultivo
                        ? { key: this.props.formValues.idCultivo }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select showSearch labelInValue
                        placeholder={"Seleccione Cultivo"}
                        optionFilterProp="children"
                        onChange={(option) => {
                          this.props.onChange(
                            "idCultivo",
                            option.key,
                            this.props.form
                          );
                        }}
                      >
                        {this.props.formValues.cultivos.map(item => (
                          <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </div>

                <div className="col-md-3 form-group">
                  <Form.Item label="Etapa Fenológica">
                    {getFieldDecorator('idFenologica', {
                      initialValue: this.props.formValues.idFenologica
                        ? { key: this.props.formValues.idFenologica }
                        : undefined,
                      rules: [
                        {
                          required: true,
                          message: "Campo obligatorio.",
                        },
                      ],
                    })(
                      <Select showSearch labelInValue
                        placeholder={"Seleccione Fenologica"}
                        optionFilterProp="children"
                      >
                        {this.props.formValues.fenologicas.map(item => (
                          <Option key={item.id} value={item.id}>{item.nombre}</Option>
                        ))}
                      </Select>
                    )}
                  </Form.Item>
                </div>
              </>
            ) : null}
          </div>

          {this.props.formValues.flagEmpresaTaller ? (
            <div className="row">

              <div className="col-md-7 form-group">
                <Form.Item label="Encargado">
                  {getFieldDecorator("encargado", {
                    initialValue: this.props.formValues.encargado,
                  })(
                    <Input placeholder="Ingresar Encargado" autoComplete="off" />
                  )}
                </Form.Item>
              </div>

              <div className="col-md-5 form-group">
                <Form.Item label="Vehículo">
                  {getFieldDecorator("idVehiculo", {
                    initialValue: this.props.formValues.idVehiculo
                      ? { key: this.props.formValues.idVehiculo }
                      : undefined,
                    rules: [
                      {
                        required: false,
                        message: "Campo obligatorio.",
                      },
                    ],
                  })(
                    <Select
                      showSearch
                      labelInValue
                      placeholder={"Seleccione Placa"}
                      optionFilterProp="children"
                    >
                      {this.props.formValues.vehiculos.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.marca + '-' + item.modelo + '-' + item.placa}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </div>
            </div>


          ) : null}


          {this.props.formValues.flagCobranzaDirecta ?
            <div className="row">
              <div className="col-md-4 form-group">
                <Form.Item label="Realizar Pago">
                  <InputGroup compact>
                    <Form.Item style={{ width: "10%" }}>
                      {getFieldDecorator("flagPago", {
                        initialValue: this.props.formValues.flagPago,
                        valuePropName: "checked",
                      })(
                        <Checkbox
                          onChange={(e) => {
                            this.props.form.setFieldsValue({
                              flagPago: !e.target.checked,
                            });
                          }}
                        ></Checkbox>
                      )}
                    </Form.Item>
                    {this.props.form.getFieldValue("flagPago") ? (

                      <Form.Item style={{ width: "90%" }}>
                        {getFieldDecorator("idCaja", {
                          initialValue: this.props.formValues.idCaja
                            ? { key: this.props.formValues.idCaja }
                            : undefined,
                          rules: [
                            {
                              required: true,
                              message: "Campo obligatorio.",
                            },
                          ],
                        })(
                          <Select
                            showSearch
                            labelInValue
                            placeholder={"Seleccione Tipo"}
                            optionFilterProp="children"
                            onChange={(option) => this.props.onChange("idCaja", option.key, this.props.form)}
                          >
                            {this.props.formValues.caja.map((item) => (
                              <Option key={item.id} value={item.id}>
                                {item.nombre}
                              </Option>
                            ))}
                          </Select>
                        )}
                      </Form.Item>

                    ) : null}


                  </InputGroup>
                </Form.Item>
              </div>


            </div>

            : null}

          <div className="row">
            <div className="col-md-12 form-group">
              <div className="custom-options">
                {[PEDIDO.ID, NOTA_VENTA.ID].includes(
                  this.props.formValues.idTipoComprobante
                ) ? (
                  <Button
                    icon="import"
                    type="primary"
                    onClick={() =>
                      this.props.onImportarCotizacion(
                        this.props.form.setFieldsValue,
                        this.props.form.getFieldValue
                      )
                    }
                  >
                    Importar Cotización
                  </Button>
                ) : null}
                {[PEDIDO.ID, NOTA_VENTA.ID].includes(
                  this.props.formValues.idTipoComprobante
                ) ? (
                  <Button
                    icon="plus"
                    type="primary"
                    onClick={() =>
                      this.props.onImportarPedido(
                        this.props.form.setFieldsValue,
                        this.props.form.getFieldValue
                      )
                    }
                  >
                    Importar Pedido
                  </Button>
                ) : null}
              </div>
            </div>

            <div className="col-md-12 form-group">
              <Tabs
                activeKey={this.props.formValues.activeKey}
                onChange={(key) => this.props.onChangeTab(key, setFieldsValue)}
                tabBarExtraContent={
                  <div className="custom-options">
                    <Button
                      icon="plus"
                      type="primary"
                      onClick={() =>
                        this.props.onAgregarDetalle(
                          this.props.form.setFieldsValue,
                          this.props.form.getFieldValue
                        )
                      }
                    >
                      Agregar
                    </Button>

                    {auth.user().planCode == "PLA001" ? (
                      <Button
                        icon="plus"
                        type="primary"
                        onClick={() => this.props.OnItemLibre(this.props.form.setFieldsValue, this.props.form)}
                      >
                        Agregar item libre
                      </Button>
                    ) : null}
                  </div>
                }
              >
                <TabPane
                  tab={
                    <span>
                      <Icon type="ordered-list" />
                      Detalle de Productos y Servicios
                    </span>
                  }
                  key="1"
                >
                  {seriePorProducto == 1 ?
                    <div className="col-md-12 form-group" style={{ marginLeft: -20 }}>
                      <div className="col-md-12 form-group">
                        <Form.Item>
                          {getFieldDecorator('flagTipoBusquedaScanner', {
                            initialValue: this.props.formValues.flagTipoBusquedaScanner
                          })(
                            <Radio.Group name="radiogroup"
                            // onChange={(e) => this.props.onChangeForm("flagTipoBusquedaScanner", e.target.value, this.props.form)}
                            >
                              <Radio value={0}>Búsqueda por código de barra</Radio>
                              <Radio value={1}>Búsqueda por serie</Radio>
                            </Radio.Group>
                          )}
                        </Form.Item>
                      </div>
                    </div> : null
                  }
                  <Productos
                    dataSource={this.props.formValues.listaComprobanteDetalle}
                    precioUnitarioDisabled={
                      this.props.formValues.precioUnitarioDetailDisabled
                    }
                    totalDisabled={this.props.formValues.totalDetailDisabled}
                    onRemove={this.handleRemoverProducto}
                    onAgregarSerie={this.props.onAgregarSerie}
                    onEditarNombreProducto={this.props.onEditarNombreProducto}
                    onCalculateDetail={this.handleCalculateDetail}
                    onGetFieldDecorator={getFieldDecorator}
                    onSetFieldsValue={setFieldsValue}
                    onGetFieldValue={getFieldValue}
                    unidadesMedida={this.props.formValues.unidadesMedida}
                    handleSelectConversion={this.props.handleSelectConversion}
                    tipoAfectacion={this.props.formValues.tipoAfectacion}

                  />
                </TabPane>
                <TabPane
                  tab={
                    <span>
                      <Icon type="unordered-list" /> Detalle de Referencias
                    </span>
                  }
                  key="2"
                >
                  <Referencias
                    dataSource={
                      this.props.formValues.listaComprobanteReferencia
                    }
                    tiposComprobante={this.props.formValues.tiposComprobante}
                    onRemove={this.props.onRemoverReferencia}
                    onGetFieldDecorator={getFieldDecorator}
                  />
                </TabPane>





                {(this.props.form.getFieldValue("flagPago") && auth.user().planCode == "PLA003") ? (
                  <TabPane

                    tab={
                      <span>
                        <Icon type="unordered-list" /> Método de Pago
                      </span>
                    }
                    key="4"
                  >
                    <MetodoPago
                      dataSource={this.props.formValues.listaComprobanteMetodoPago}
                      metodosPagos={this.props.formValues.metodosPagos}
                      cuentas={this.props.formValues.cuentas}
                      onRemove={this.props.onRemoverMetodoPago}
                      onGetFieldDecorator={getFieldDecorator}
                      onSetFieldsValue={setFieldsValue}
                    />
                  </TabPane>

                ) : null}


              </Tabs>
            </div>
          </div>
          <Footer
            formValues={this.props.formValues}
            onChangeTotals={this.handleChangeTotals}
            onGetFieldDecorator={getFieldDecorator}
            onGetFieldValue={getFieldValue}
          />
        </Form>
      </Modal>
    );
  }
}
export default Form.create()(FormModal);
